import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://foglio-vendite-dev.firebaseio.com/'

    // baseURL: 'https://foglio-vendite-default-rtdb.firebaseio.com/'
});

export default instance;